import { Pipe, PipeTransform } from '@angular/core';
import { AppConfigService } from '@app/common/app-config.service';

@Pipe({
  name: 'localPatientNameDisplay'
})
export class LocalPatientNameDisplayPipe implements PipeTransform {
  patientNameType: any;

  constructor(private appConfigService: AppConfigService) {
    this.patientNameType = this.appConfigService.getAppConfigByKey('wfmTabNameConfigured');
  }

  transform(patientName): string {
    let displayName = '';
    if (patientName) {
      switch (this.patientNameType) {
        case 'PID_LOCAL_PAT_NAME': {
          displayName = patientName.ideographicName;
          break;
        }

        case 'PID_PHONETIC_PAT_NAME': {
          displayName = patientName.phoneticName;
          break;
        }

        default: {
          displayName = LocalPatientNameDisplayPipe.getPatientName(patientName, displayName);
        }
      }
      if (!displayName) {
        displayName = LocalPatientNameDisplayPipe.getPatientName(patientName, displayName);
      }
      return displayName;
    }
  }

  private static getPatientName(patientName: any, displayName: string) {
    const name = [];
    let middleName = '';
    if (patientName.family) {
      name.push(patientName.family);
    }

    if (patientName.given) {
      name.push(patientName.given);
    }
    let pName = name.join(', ');

    if (patientName.middle) {
      middleName = patientName.middle;
      pName = [pName, middleName].join(' ');
    }
    displayName = pName || patientName.text;
    return displayName;
  }
}
